export default "__VITE_ASSET__2be146c3__"